// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1T7ZA{margin:0 0 6rem}._1T7ZA,.JEhWL{height:92px;height:9.2rem;position:relative;width:92px;width:9.2rem}.JEhWL{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;background-color:#c9cfdc;border-radius:50%;justify-content:center;overflow:hidden}._10G3f{height:100%;width:auto}._3T3BO{bottom:0;height:22px;height:2.2rem;overflow:visible;right:0;width:22px;width:2.2rem}._3T3BO,._3T3BO:before{border-radius:50%;position:absolute}._3T3BO:before{background:#f5f9ff;bottom:-2px;content:\" \";left:-2px;right:-2px;top:-2px}._3T3BO .btn{border-radius:50%;height:100%;line-height:1.1;opacity:1!important;width:100%}._3-19I{fill:#fff;height:12px;height:1.2rem;width:12px;width:1.2rem}.NW1HB{font-size:14px;font-size:1.4rem;line-height:18px;line-height:1.8rem;margin-bottom:16px}", ""]);
// Exports
exports.locals = {
	"avatar": "_1T7ZA",
	"avatar__imgWrapper": "JEhWL",
	"avatar__img": "_10G3f",
	"avatar__btn": "_3T3BO",
	"avatar__btn__icon": "_3-19I",
	"marketingConsents": "NW1HB"
};
module.exports = exports;
